import { HOME } from '@/constants';

export const home = {
  [HOME.RANGE.MONTH]: 'Month',
  [HOME.RANGE.TODAY]: 'Today',
  [HOME.RANGE.WEEK]: 'Week',
};
